// Cookie notice
(function(){
var notice = $("#cookie-notice");
if(notice.length) {
    if(!getCookie("cookie-notice")) {
        $(notice).addClass('active');
    }
    $(document).on( 'click', ".js-accept-cookies, .js-cookie-close", function(){
        $(notice).removeClass('active');
        setCookie("cookie-notice", "accepted", 999);
    });
}
})();


// Cookie functions
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
/* eslint-disable */
function eraseCookie(name) {
    document.cookie = name+'=; Max-Age=-99999999; path=/';
}
/* eslint-enable */



// Accordion
{
    const accordions = document.querySelectorAll('.js-accordion-pair');
  
    for (const accordion of accordions) {
      const accHeader = accordion.querySelector('.js-accordion-header');
      const accBody = accordion.querySelector('.js-accordion-body');
      if (accHeader && accBody) {
        const accHeaderArrow = accHeader.querySelector('.js-accordion-header-arrow');
        const accBodyHeight = accBody.clientHeight;
  
        accBody.style.height = 0;
  
        accHeader.addEventListener('click', () => {

          for (const accordion of accordions) {
            const accBodies = accordion.querySelector('.js-accordion-body');
            const accHeader = accordion.querySelector('.js-accordion-header');
            const accHeaderArrow = accHeader.querySelector('.js-accordion-header-arrow');
            accBodies.style.height = 0;
            accHeaderArrow.classList.remove('active');
          }

          let accHeight = accBody.clientHeight === 0 ? accBodyHeight : 0;
          accBody.style.height = accHeight+'px';
  
          if (!accHeaderArrow) return;
  
          if ( accBody.clientHeight === 0 ) {
            accHeaderArrow.classList.add('active');
          } else {
            accHeaderArrow.classList.remove('active');
          }
        });
      }
    }
  }




  let body = $('body');
  let menuTrigger = $('header .menu-burger');
  let menuContainer = $('.mobile-menu-fixed');
  let closeTrigger = menuContainer.find('.close-burger');
  
  let searchTrigger = $('header .js-search-open');
  let searchContainer = $('.search-form-wrap');
  let closeSearchTrigger = searchContainer.find('.js-close');

  let linkTrigger = menuContainer.find('.middle nav li.menu-item-has-children a');

    searchTrigger.on('click', function () {
        if (searchTrigger.hasClass('active') && searchContainer.hasClass('active')) {
            searchTrigger.removeClass('active');
            searchContainer.removeClass('active');
        } else {
            searchTrigger.addClass('active');
            searchContainer.addClass('active');
        }
    });

    menuTrigger.on('click', function () {
        if (menuTrigger.hasClass('active') && menuContainer.hasClass('active')) {
            menuTrigger.removeClass('active');
            menuContainer.removeClass('active');
            body.removeClass('fixed-body');
        } else {
            body.addClass('fixed-body');
            menuTrigger.addClass('active');
            menuContainer.addClass('active');
        }
    });

  linkTrigger.on('click', function () {
      var subMenu = $(this).parents('li').find('ul.sub-menu');

      if ($(this).hasClass('active') && subMenu.hasClass('active')) {
          $(this).removeClass('active');
          subMenu.removeClass('active');
          subMenu.slideUp();
      } else {
          $(this).addClass('active');
          subMenu.addClass('active');
          subMenu.slideDown();
      }
  });

    closeTrigger.on('click', function () {
        menuTrigger.removeClass('active');
        menuContainer.removeClass('active');
        body.removeClass('fixed-body');
    });

    closeSearchTrigger.on('click', function () {
        searchTrigger.removeClass('active');
        searchContainer.removeClass('active');
    });

    
    
    if ($( 'form > .grid  .font-heading ~ #mp-wc-pickup-point-shipping' ).length) {
        $( 'form > .grid  .font-heading ~ #mp-wc-pickup-point-shipping' ).appendTo( $('.shipping-container .col-span-8'))
    }
    $(document).ajaxComplete(function() {
        if ($( 'form > .grid  .font-heading ~ #mp-wc-pickup-point-shipping' ).length) {
            $( 'form > .grid  .font-heading ~ #mp-wc-pickup-point-shipping' ).appendTo( $('.shipping-container .col-span-8'))
        }
    });


  $(document).mouseup(function (e) {
    if (!menuContainer.is(e.target) && menuContainer.has(e.target).length === 0) {
        menuTrigger.removeClass('active');
        menuContainer.removeClass('active');
        body.removeClass('fixed-body');
    }
    if (!searchContainer.is(e.target) && searchContainer.has(e.target).length === 0) {
        searchTrigger.removeClass('active');
        searchContainer.removeClass('active');
    }
});

